import { isApiSuccess, getErrorMessage } from "../utils/error-handler";

const promisify = (method, args, expectedStatus = 200) =>
  new Promise((resolve, reject) => {
    method(...args, (error, data, response) => {
      if (isApiSuccess(error, response, expectedStatus)) {
        resolve(data);
      } else {
        reject(new Error(getErrorMessage(error, response)));
      }
    });
  });

export function createGameSessionApiAdapter(gameSessionApi) {
  return {
    getActiveGameSession: (sessionType) =>
      promisify(gameSessionApi.getActiveGameSession.bind(gameSessionApi), [sessionType]),
    getUserGameSessions: () =>
      promisify(gameSessionApi.getUserGameSessions.bind(gameSessionApi), []),
    getGameSessionById: (sessionId) =>
      promisify(gameSessionApi.getGameSessionById.bind(gameSessionApi), [sessionId]),
    getGameSessionProgress: (sessionId) =>
      promisify(gameSessionApi.getGameSessionProgress.bind(gameSessionApi), [sessionId]),
    getGameSessionStatistics: (sessionId) =>
      promisify(gameSessionApi.getGameSessionStatistics.bind(gameSessionApi), [sessionId]),
    closeGameSession: (sessionId) =>
      promisify(gameSessionApi.closeGameSession.bind(gameSessionApi), [sessionId], 204),
    markPageAsCompleted: (sessionId, pageId) =>
      promisify(gameSessionApi.markPageAsCompleted.bind(gameSessionApi), [sessionId, pageId], 204),
  };
}
